export default __webpack_public_path__ + "static/media/desiredJob.62b993bc.svg";